import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { Btn } from "./Reveal";
import { NAV } from "@/content";

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");
const linkCls = "relative font-head text-[13px] text-[var(--ink)] whitespace-nowrap py-2 after:absolute after:left-0 after:-bottom-0.5 after:h-[2px] after:bg-[var(--ink)] after:transition-[width] after:duration-300";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-b border-[var(--line)]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-12 h-[76px] flex items-center justify-between gap-6">
        <Logo testId="nav-logo-link" />
        <nav className="hidden xl:flex items-center gap-8">
          {NAV.map((i) => (
            <NavLink key={i.to} end to={i.to} data-testid={`nav-${slug(i.label)}`} className={({ isActive }) => `${linkCls} ${isActive ? "after:w-full font-semibold" : "after:w-0 hover:after:w-full"}`}>
              {i.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Btn to="/signup" testId="nav-signup-btn" className="hidden sm:inline-flex !px-8 !py-3">Sign Up</Btn>
          <button data-testid="nav-menu-toggle" aria-label="Toggle menu" onClick={() => setOpen((v) => !v)} className="xl:hidden h-11 w-11 grid place-items-center border border-[var(--line)]">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="xl:hidden bg-white px-5 sm:px-8 pb-8 flex flex-col max-h-[calc(100vh-76px)] overflow-y-auto">
          {NAV.map((i) => (
            <NavLink key={i.to} end to={i.to} data-testid={`mobile-nav-${slug(i.label)}`} className="headline text-2xl py-3 border-b border-[var(--line)]">
              {i.label}
            </NavLink>
          ))}
          <Btn to="/signup" testId="mobile-nav-signup-btn" className="mt-6 w-full">Sign Up</Btn>
        </div>
      )}
    </header>
  );
}
